<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span>Transaction Details</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Transaction Date / Time:">
              <a-input v-model.trim="formData.transaction_date" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Transaction Number:">
              <a-input v-model="transaction_number" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Branch:">
              <a-input v-model="branch" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Member ID:">
              <a-input v-model="member_id" disabled />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Card Number:">
              <a-input v-model="formData.card_number" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Item Code:">
              <a-input v-model="item_code" disabled />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Points Used:">
              <a-input v-model="points_used" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Transacted By:">
              <a-input v-model="transacted_by" disabled />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto">
              <template>
                <div>
                  <a-spin :spinning="formSubmitting">
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click.prevent="openModal"
                    >
                      Print
                    </b-button>
                  </a-spin>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
    <a-modal class="receipt-modal" v-model="printReceiptModal" width="464px">
      <div class="py-2">
        <div class="text-left" id="printable-content">
          <span><h4>Transaction Details</h4></span> <br />
          <span>Transaction Date / Time: {{ formData.transaction_date }}</span>
          <br />
          <span>Transaction Number: {{ transaction_number }}</span>
          <br />
          <span>Member ID: {{ member_id }}</span> <br />
          <span>Branch: {{ branch }}</span> <br />
          <span>Card number: {{ formData.card_number }}</span> <br />
          <span>Item Code: {{ item_code }}</span> <br />
          <span>Points Used: {{ points_used }}</span> <br />
          <span>Transacted By: {{ transacted_by }}</span>
          <br />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<style>
.receipt-modal .ant-modal-header,
.receipt-modal .ant-modal-close,
.receipt-modal .ant-modal-footer {
  display: none !important;
}

.dotted-line {
  background-image: linear-gradient(
    to right,
    black 33%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 3px 1px;
  background-repeat: repeat-x;
}

@media print {
  @page {
    size: 80mm 90mm; /* Set the paper size */
    margin: 0; /* Remove default margins */
  }

  body {
    margin: 0; /* Reset margins for body */
    padding: 0;
    overflow: hidden;
  }

  body * {
    visibility: hidden;
  }

  .ant-modal,
  .ant-modal * {
    visibility: visible;
  }

  .ant-modal-header,
  .ant-modal-close,
  .ant-modal-footer {
    display: none !important;
  }

  .dotted-line {
    display: none;
  }
}
</style>
<script>
import secureStorage from '@/controllers/secureStorage';
import printJS from 'print-js';
import moment from 'moment';

export default {
  name: 'TransactionDetailForm',
  props: {
    viewMode: Boolean,
    itemTransactionData: Object
  },
  data() {
    return {
      formSubmitting: false,
      printReceiptModal: false,
      cardStatusCode: null,
      transacted_by: secureStorage.getItem('username'),
      formData: {
        transaction_date: this.itemTransactionData.transaction_date,
        transaction_number: this.itemTransactionData.referenceId,
        branch: this.itemTransactionData.branch,
        member_id: this.itemTransactionData.membership_number,
        card_number: this.itemTransactionData.card_number,
        item_code: this.itemTransactionData.item_code,
        points_used: this.itemTransactionData.points
      }
    };
  },

  methods: {
    closeDrawer(successTransaction = false) {
      this.$emit('closeDrawer', successTransaction);
    },

    openModal() {
      this.printReceiptModal = true;
      setTimeout(() => {
        printJS({
          printable: 'printable-content',
          type: 'html',
          maxWidth: '100%',
          targetStyles: ['*'],
          font_size: '12px;'
        });
      }, 300);
    },
    setFormData(data = null) {
      if (data !== null) {
        const { transaction_date } = data;
        if (transaction_date) {
          this.formData.transaction_date = moment
            .utc(transaction_date)
            .format('MM/DD/YYYY hh:mm A');
        }
      }
    }
  },

  mounted: function () {
    this.transacted_by = secureStorage.getItem('username');
  },
  computed: {
    member_id() {
      return this.itemTransactionData?.member_id;
    },
    branch() {
      return this.itemTransactionData?.branch;
    },
    transaction_number() {
      return this.itemTransactionData?.transaction_number;
    },
    item_code() {
      return this.itemTransactionData?.item_code;
    },
    points_used() {
      return this.itemTransactionData?.points_used;
    }
  },

  created() {
    if (!this.viewMode) {
      setTimeout(() => {
        this.openModal();
      }, 600);
    }
    this.setFormData(this.itemTransactionData);
  },
  watch: {
    itemTransactionData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>
